import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { QuickBooksStatusResponse, fetchQuickBooksStatus } from 'api/quickBooks';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';
import { GivebutterAxiosError } from 'types/error';

type UseQuickBooksStatusOptions<TData = QuickBooksStatusResponse> = Omit<
    UseSuspenseQueryOptions<QuickBooksStatusResponse, GivebutterAxiosError, TData, any>,
    'queryKey' | 'queryFn'
>;

const useQuickBooksStatus = <TData = QuickBooksStatusResponse>(
    options?: UseQuickBooksStatusOptions<TData>,
) => {
    const { accountId } = useCurrentAccount();

    return useSuspenseQuery<QuickBooksStatusResponse, GivebutterAxiosError, TData>({
        queryKey: accountQueryKeys.quickBooksStatus(accountId),
        queryFn: () => fetchQuickBooksStatus(accountId),
        refetchOnMount: 'always',
        ...options,
    });
};

export { useQuickBooksStatus };
export type { UseQuickBooksStatusOptions };
